export default class fabHelper {
    constructor() {
        Object.assign(this, {});
    }
    test() {
        console.log("tested ok!");
    }
    getDatalength(obj) {
        if (typeof obj === "object" && obj !== null) {
            return Object.keys(obj).length;
        } else {
            return false;
        }
    }
    makeInteger(data) {
        return parseFloat(data).toFixed(0);
    }

    makeDecimal(data) {
        return parseFloat(data).toFixed(2);
    }

    /*makeMoney(number, decPlaces = 2, decSep = ".", thouSep = ",") {
        (decPlaces = isNaN((decPlaces = Math.abs(decPlaces))) ? 2 : decPlaces),
            (decSep = typeof decSep === "undefined" ? "." : decSep);
        thouSep = typeof thouSep === "undefined" ? "," : thouSep;
        var sign = number < 0 ? "-" : "";
        var i = String(
            parseInt(
                (number = Math.abs(Number(number) || 0).toFixed(decPlaces))
            )
        );
        var j = (j = i.length) > 3 ? j % 3 : 0;

        return (
            sign +
            (j ? i.substr(0, j) + thouSep : "") +
            i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
            (decPlaces
                ? decSep +
                  Math.abs(number - i)
                      .toFixed(decPlaces)
                      .slice(2)
                : "")
        );
    }*/
    makeMoney(number, currency = "USD", showPrefix = true) {
        if (showPrefix) {
            var formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: currency,
                maximumFractionDigits: 0,
            });
        } else {
            var formatter = new Intl.NumberFormat("en-US", {
                style: "decimal",
                maximumFractionDigits: 0,
            });
        }
        return formatter.format(number);
    }

    validateEmail(mail) {
        if (/^\S+@\S+$/.test(mail)) {
            return true;
        }
        return false;
    }
    validatePhone(phone) {
        if (
            /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(
                phone
            )
        ) {
            return true;
        }
        return false;
    }
}
